"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _styles = _interopRequireDefault(require("./styles"));
var _location = require("../../lib/location");
var _messages = _interopRequireDefault(require("../../lib/constants/messages"));
var _globals = require("../../lib/constants/globals");
const MapLink = _ref => {
  let {
    location,
    searchedLocation,
    track,
    intl
  } = _ref;
  // Intl message descriptor for the link text
  let linkTextMessageDescriptor;
  const handleClick = () => {
    track(_globals.LOGGING.MESSAGE.MAP_LINK_CLICKED, {
      location_name: location.name,
      map_type: linkTextMessageDescriptor.defaultMessage
    });
  };
  let googleMapValues = (0, _location.getGoogleMapValues)(location, searchedLocation);
  if (searchedLocation) {
    linkTextMessageDescriptor = _messages.default.directionslink;
  } else {
    linkTextMessageDescriptor = _messages.default.maplink;
  }
  return /*#__PURE__*/_react.default.createElement(_styles.default, {
    onClick: handleClick,
    href: googleMapValues.href,
    target: '_blank',
    "aria-label": intl.formatMessage(_messages.default.maplinklabel, {
      location: googleMapValues.locationString
    })
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, linkTextMessageDescriptor));
};
var _default = exports.default = (0, _intl.injectIntl)(MapLink);
MapLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MapLink"
};